import React from 'react'
import { BsFillTrashFill } from 'react-icons/bs'
import { FlexRow } from 'components/common/Containers'
import { BrandMonitorWatchlistItem } from 'models/tools.interface'
import styles from './WatchlistItem.module.scss'

interface Props {
  watchlistItem: BrandMonitorWatchlistItem
  onDelete: (id: number) => void
}

const WatchlistItem: React.FC<Props> = ({ watchlistItem, onDelete }) => {
  return (
    <FlexRow className={styles.watchlistItem} align="center" gap="5px">
      <span className={styles.text}>{watchlistItem.keyword}</span>

      <BsFillTrashFill
        className={styles.trashIcon}
        onClick={() => onDelete(watchlistItem.id)}
      />
    </FlexRow>
  )
}

export default WatchlistItem
